import React, { useEffect, useContext, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { LinearProgress, Dialog, DialogTitle, DialogContentText, DialogContent, colors, TextField, Button } from '@material-ui/core';
import { NavContext, NavRoutes, UserContext } from '../../contexts';
import { RequestStatus } from '../../../helpers'
import { TabsContainer } from './components';
import { makeStyles } from '@material-ui/core/styles';
import { CostumerRequestProvider, CustomerRequestContext } from './CustomerRequestContext';
import Autocomplete, { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete';
import { ApplicationRoles, DbType } from '../../../helpers/Common';
import { SearchUser } from '../../common';

const useStyles = makeStyles({
    root: {
    }
});

const PageContent = (props) => {
    const classes = useStyles();

    const { requestId } = useParams();
    const location = useLocation();
    
    const { isUserInRole } = useContext(UserContext);

    const {
        setBreadcrumbTokens,
        setBreadcrumbRoot
    } = useContext(NavContext);

    const {
        state,
        isLoadingDefs,
        getChoosenTableDefinitions,
        isLoadingSalesGroup,
        getSalesGroups,
        isLoadingBuCategories,
        getUserBusinessCategories,
        isLoadingCompanies,
        getUserCompanies,
        getRespAreas,
        getSalesOffices,
        getSalesOrgsAsync,
        getCustomerGroup7,
        getCustomerGroup8,
        getCustomerGroup9,
        getCustomerGroup10,
        isLoadingCg6,
        getSegments,
        getInfoTypes,
        getCustGroupsWithAccGroupECC,
        getCustGroupsWithAccGroupS4,
        getReconciliationAccounts,
        getAccountingClerks,
        getTaxCategories,
        loadRequestDbType,
        loadRequest,
        getRequestSavedObsoleteDataECC,
        createEmptyRequest
    } = useContext(CustomerRequestContext);

    const { requestDbType, request, userCompanies } = state;
    
    const [openerInfo, setOpenerInfo] = useState<any>(null);
    const [selectedCompany, setSelectedCompany] = useState<any>();
    const [isFormReady, setIsFormReady] = useState<boolean>(!!requestId);
    const [isRedFlagsDialog, setIsRedFlagsDialog] = useState(true);
    const [isLoadingData, setIsLoadingData] = useState<boolean>(!!requestId);

    useEffect(() => {
        if (
            !requestId &&
            !isUserInRole(ApplicationRoles.BossApprover)
        )
            getUserCompanies();
    }, []);

    useEffect(() => {
        if (
            !requestId &&
            isUserInRole(ApplicationRoles.BossApprover) &&
            openerInfo
        ){
            setSelectedCompany(null);
            getUserCompanies(openerInfo.externalKey);
        }
    }, [openerInfo?.externalKey]);

    useEffect(() => {
        if (userCompanies?.length === 1){
            setSelectedCompany(userCompanies[0]);
            setIsFormReady(true);
        }
    }, [userCompanies]);

    useEffect(() => {
        setIsLoadingData(
            //the initial loading of the userCompanies
            (
                !isFormReady &&
                !isUserInRole(ApplicationRoles.BossApprover) &&
                isLoadingCompanies
            ) ||
            //after clicking next
            (
                isFormReady && (
                    isLoadingDefs ||
                    isLoadingSalesGroup ||
                    isLoadingBuCategories ||
                    request === null
                )
            )
        );
    }, [isLoadingDefs, isLoadingSalesGroup, isLoadingBuCategories, isLoadingCompanies, isLoadingCg6, request]);

    useEffect(() => {
        if (isFormReady){
            setIsLoadingData(true);
    
            if (requestId)
                loadRequestDbType(requestId);
            else
                createEmptyRequest(selectedCompany, openerInfo);
        }
    }, [requestId, isFormReady]);

    useEffect(() => {
        if (requestDbType === DbType.ECC || requestDbType === DbType.S4)
            loadRequest(requestId, requestDbType); //retrieving request record from CustomerRequests table

        if (requestDbType === DbType.ECC)
            getRequestSavedObsoleteDataECC(requestId, requestDbType); //retrieving values belonging to this cutomer request from TableValues (also obsolete values which is the only reason why this API exists)
    }, [requestDbType]);

    useEffect(() => {
        if (request != null) {
            getChoosenTableDefinitions(request.dbType);

            if (request.ownerKey !== "" && request.ownerKey !== null){                
                getSalesGroups(request.ownerKey, request.dbType);
                getUserBusinessCategories(request.ownerKey, request.dbType);
                getUserCompanies(request.ownerKey);

                if (request.dbType === DbType.S4){
                    getCustomerGroup7();
                    getCustomerGroup8(request.salesOrganizationId);
                    getCustomerGroup9();
                    getCustomerGroup10(request.responsibilityAreaId);

                    if (
                        request.status !== RequestStatus.Draft &&
                        request.status !== RequestStatus.ToBeReviewed &&
                        request.status !== RequestStatus.BossApproval
                    )
                        getSegments(request.salesOrganizationId, request.distributionChannelId);
                }
            }

            if (request.salesGroupId !== "")
                getRespAreas(request.salesGroupId, request.dbType);

            if (
                request.salesOrganizationId !== "" &&
                (
                    request.status === RequestStatus.AccountReceivableApproval ||
                    request.status === RequestStatus.WaitingToBeAddedInSap ||
                    request.status === RequestStatus.Approved
                )
             )
                getTaxCategories(
                    request.salesOrganizationId,
                    request.dbType === DbType.ECC && request.status === RequestStatus.Approved,
                    request.dbType
                );

            if (
                request.dbType === DbType.S4 &&
                request.status === RequestStatus.CreditRiskEvaluation
            )
                getInfoTypes();

            if (request.salesGroupId !== "" && request.salesOrganizationId !== "")
                getSalesOffices(request.salesGroupId, request.salesOrganizationId, request.dbType);

            if (request.salesOrganizationId !== "" && request.businessCategoryId !== ""){
                if (request.dbType === DbType.ECC)
                    getCustGroupsWithAccGroupECC(request.salesOrganizationId, request.businessCategoryId);
                else
                    getCustGroupsWithAccGroupS4(request.salesOrganizationId, request.businessCategoryId);
            }

            if (request.companyId != "") {
                getSalesOrgsAsync(request.companyId, request.dbType);

                if (
                    request.status === RequestStatus.AccountReceivableApproval ||
                    request.status === RequestStatus.WaitingToBeAddedInSap ||
                    request.status === RequestStatus.Approved
                ){
                    getReconciliationAccounts(
                        request.companyId,
                        request.dbType === DbType.ECC && request.status === RequestStatus.Approved,
                        request.dbType
                    );

                    getAccountingClerks(
                        request.companyId,
                        request.accountReceivable?.accountingClerkId,
                        request.dbType === DbType.ECC && request.status === RequestStatus.Approved,
                        request.dbType
                    );
                }
            }

            const finalToken = requestId ?
                {
                    title: "Edit Request",
                    url: location.pathname
                } :
                {
                    title: "New Request",
                    url: location.pathname
                };

            if (requestId) {
                if (request) {
                    if (request.status === RequestStatus.Draft)
                        setBreadcrumbTokens([{ title: "Draft Requests", url: NavRoutes.DraftRequests }, finalToken]);

                    else if (request.status === RequestStatus.Approved)
                        setBreadcrumbTokens([{ title: "Completed Requests", url: NavRoutes.CompletedRequests }, finalToken]);

                    else
                        setBreadcrumbTokens([{ title: "Running Requests", url: NavRoutes.RunningRequests }, finalToken]);
                }
            }
            else
                setBreadcrumbRoot("New Request");
        }
    }, [request]);

    const userChangeHandler = (user) => {
        setOpenerInfo(user ?? null);
    };

    const boxContainer: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    };

    const boxBody: React.CSSProperties = {
        padding: '50px',
        borderRadius: '20px',
        minWidth: '80%',
        textAlign: 'center',
        alignSelf: 'center'
    };
    
    const CompanySelection = () => {
        const autocompleteStyle: React.CSSProperties = {
            margin: '50px 0px'
        };
    
        const buttonStyle: React.CSSProperties = {
            background: colors.grey[300],
            width: 100
        };
    
        return (
            <div style={boxContainer}>
                <div style={boxBody}>
                    <div style={{ fontSize: "1.5rem", marginBottom: '25px' }}>
                        {
                            isUserInRole(ApplicationRoles.BossApprover) ?  
                            "Select AOF Opener's company" :
                            "Select your company"
                        }
                    </div>

                    <Autocomplete
                        id="combo-box"
                        style={autocompleteStyle}
                        disabled={
                            isLoadingCompanies ||
                            !(
                                !isUserInRole(ApplicationRoles.BossApprover) ||
                                openerInfo?.externalKey
                            )
                        }
                        options={userCompanies}
                        getOptionLabel={(option: any): string =>
                            `${option.externalKey} - ${option.value}`
                        }
                        value={selectedCompany}
                        onChange={(e, option) => setSelectedCompany(option)}
                        renderInput={(params: AutocompleteRenderInputParams): JSX.Element =>
                            <TextField
                                {...params}
                                label="Companies"
                                variant="outlined"
                                helperText={
                                    isUserInRole(ApplicationRoles.BossApprover) ?
                                    "They have been assigned to AOF Opener" :
                                    "They have been assigned to you"
                                }
                            />
                        }
                    />

                    <Button
                        style={buttonStyle}
                        size="medium"
                        type="button"
                        onClick={() => setIsFormReady(true)}
                        disabled={!selectedCompany}
                    >
                        Next
                    </Button>
                </div>
            </div>
        );
    };

    return (
        <>
            {
                isLoadingData ?
                <LinearProgress color="primary" /> :

                !isFormReady ?
                <>
                    {
                        isUserInRole(ApplicationRoles.BossApprover) &&
                        <div style={boxContainer}>
                            <div style={boxBody}>
                                <div style={{ fontSize: "1.5rem", marginBottom: '25px' }}>
                                    Assign the request to this AOF Opener
                                </div>
                                <SearchUser
                                    isAllUsers={false}
                                    getOptionLabel={option => `${option.displayName} (${option.mail})`}
                                    getOptionValue={option => option.id}
                                    onChange={userChangeHandler}
                                />
                            </div>
                        </div>
                    }

                    <CompanySelection />
                </> :

                state.request &&
                <>
                    {
                        state.request.status === RequestStatus.Blocked &&
                        <Dialog
                            open={isRedFlagsDialog}
                            onClose={() => setIsRedFlagsDialog(false)}
                        >
                            <DialogTitle style={{ padding: '25px 40px 5px' }}>
                                The request has been suspended
                            </DialogTitle>
                            <DialogContent style={{padding: "20px 40px" }}>
                                <DialogContentText style={{ color: "black" }}>
                                    "Red flags" detected!
                                    <br/>
                                    E&C, Sales, and Credit Risk intervention required.
                                </DialogContentText>
                            </DialogContent>
                        </Dialog>
                    }
                        
                    <TabsContainer editMode={requestId ? true : false} />
                </>
            }
        </>
    );
}

export const CustomerRequestPage = () => {
    return (
        <CostumerRequestProvider>
            <PageContent />
        </CostumerRequestProvider>
    );
}